<template>
    <as-modal title="No Credit Impact" @close="$emit('close', $event)">
        <p>Providing your online banking details to AccountScore will not leave a footprint on your credit report.</p>
        <p>{{client}} may have obtained a credit report to evaluate your application.</p>
    </as-modal>
</template>

<script>
    import AsModal from '../Ui/AsModal.vue'
    import settingsHelper from "@/store/modules/settings/helper.ts"
    const settingsHelpers = settingsHelper.mapGetters(["client"])
    export default {
        name: 'NoCreditImpact',
        components: {
            AsModal,
        },
        computed: {
            ...settingsHelpers
        }
    }
</script>
